"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.select = void 0;
var kage_1 = require("../kage");
var mincho_1 = __importDefault(require("./mincho"));
var gothic_1 = __importDefault(require("./gothic"));
var mincho_2 = require("./mincho");
Object.defineProperty(exports, "Mincho", { enumerable: true, get: function () { return mincho_2.default; } });
var gothic_2 = require("./gothic");
Object.defineProperty(exports, "Gothic", { enumerable: true, get: function () { return gothic_2.default; } });
function select(shotai) {
    switch (shotai) {
        case kage_1.KShotai.kMincho:
            return new mincho_1.default();
        default:
            return new gothic_1.default();
    }
}
exports.select = select;
